// extracted by mini-css-extract-plugin
module.exports = {"buyer_head":"Buyer_buyer_head__2zXtO","buyer_body":"Buyer_buyer_body__1JmQ4"};